export default "__VITE_ASSET__b9e3ecf8__"